import React from 'react';
import Proptypes from 'prop-types';
//MUI
import TabsMui from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import IconButton from '@material-ui/core/IconButton';
//ICONS
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
//DS
import {defaults} from 'lib.common';

function Tabs({
   selectedTab,
   onSelectedTabChange,
   tabList,
   genTabProps,
   mostrarCerrar,
   onCloseTab,
   tabConfig,
   ...other
}) {
   function handleTabChange(e, tab) {
      //click en el tab
      if (e.target.tagName === 'SPAN' || e.target.tagName === 'BUTTON') {
         onSelectedTabChange(e, tab);
      }
      //click en el boton cerrar
      if (e.target.tagName === 'path' || e.target.tagName === 'svg') {
         if (tab >= 0 && tabList.length > 1) {
            if (tab <= selectedTab) {
               onSelectedTabChange(e, selectedTab - 1);
            }
         }
         onCloseTab(tab);
      }
   }
   return (
      <TabsMui
         value={selectedTab}
         onChange={handleTabChange}
         variant="scrollable"
         scrollButtons="auto"
         {...other}
      >
         {tabList.map((item, index) => {
            const tabProps = genTabProps(item, index);
            return (
               <Tab
                  key={index}
                  label={
                     <span>
                        {tabProps.label}
                        {tabProps.mostrarCerrar && (
                           <IconButton size="small" component="div">
                              <HighlightOffIcon />
                           </IconButton>
                        )}
                        {tabProps.mostrarCerrar == null && mostrarCerrar && (
                           <IconButton size="small" component="div">
                              <HighlightOffIcon />
                           </IconButton>
                        )}
                     </span>
                  }
               />
            );
         })}
      </TabsMui>
   );
}
Tabs.propTypes = {
   /**
    * Indice del tab elegido.
    */
   selectedTab: Proptypes.number,
   /** Funcion a ejecutar cuando se hace click en un tab. Con firma especificada por [Material UI Tabs](https://v4.mui.com/api/tabs/)
    */
   onSelectedTabChange: Proptypes.func,
   /** Funcion a ejecutar cuando se hace click en el boton cerrar de un tab, con la siguiente firma:
    *
    * - `index`: number, posicion del `item` en el arreglo `tabList` sobre el cual se realizo el click.
    * - `retorno`: void.
    * */
   onCloseTab: Proptypes.func,
   /** Lista de los objetos mostrados como tabs. */
   tabList: Proptypes.arrayOf(Proptypes.any).isRequired,
   /** Función generadora de propiedades individuales de los tabs, con la siguiente firma:
    *
    * - `item`: object, con la misma forma a los del array de la propiedad `tabList`.
    * - `index`: number, posicion del `item` en el arreglo `tabList`.
    * - `retorno`: object con las siguientes propiedades:
    *       - `label`: string, Texto que se desea mostrar en el tab, es obligatorio.
    *       - `mostrarCerrar`: boolean, Si es __true__ se mostrar el boton cerrar en el tab.
    *       - Cualquier otra propiedad sera referida a [Material UI Tab](https://v4.mui.com/api/tab/)
    * */
   genTabProps: Proptypes.func,
   /**
    * Si es __true__ se mostrara el boton cerrar los tabs.
    */
   mostrarCerrar: Proptypes.bool
};
Tabs.defaultProps = {
   genTabProps: function(item, index) {
      return {label: item};
   },
   onSelectedTabChange: defaults.funcionVacia,
   onCloseTab: defaults.funcionVacia,
   mostrarCerrar: false
};
export default Tabs;
